import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const navLinks = [{
  name: 'Home',
  path: '/'
}, {
  name: 'About',
  path: '/about'
}, {
  name: 'Podcasts',
  path: '/podcasts',
  dropdown: [{
    name: 'All Episodes',
    path: '/podcasts'
  }, {
    name: 'Season 1',
    path: '/podcasts/season-1'
  }, {
    name: 'Season 2',
    path: '/podcasts/season-2'
  }]
}, {
  name: 'Guests',
  path: '/guests'
}, {
  name: 'Outreach',
  path: '/outreach',
  dropdown: [{
    name: 'Operation Olive Branch',
    path: '/outreach'
  }, {
    name: 'The Million Movement',
    path: '/million-movement'
  }, {
    name: 'Ends Adventures',
    path: '/ends-adventures'
  }]
}, {
  name: 'Bookstore',
  path: '/bookstore'
}, {
  name: 'Share',
  path: '/share'
}];
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [expandedMobile, setExpandedMobile] = useState<string | null>(null);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu when route changes
  useEffect(() => {
    setIsOpen(false);
    setExpandedMobile(null);
  }, [location]);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-dark-700/90 backdrop-blur-md border-b border-dark-600 py-3' : 'bg-transparent py-5'}`} data-id="element-86" data-mp="5ne5z3tvpvse">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87" data-mp="39bfssz9rclf3">
        <div className="flex items-center justify-between" data-id="element-88" data-mp="399uxh7fmcyg6">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group" data-id="element-89" data-mp="319gm8xry89se">
            <img src="https://cdn.magicpatterns.com/uploads/ue8vBFZwEq6iFGtuLhrkM6/Podcastlogo3doves.jpg" alt="3 Doves Podcast" className="h-10 w-10 rounded-full border border-gold-500/30 group-hover:border-gold-500 transition-colors" data-id="element-90" data-mp="2wb5d6p9ha3b8" />
            <span className="text-xl font-serif font-bold text-dark-50 group-hover:text-gold-400 transition-colors" data-id="element-91" data-mp="2ibm67zseky0i">
              3 Doves Podcast
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-92" data-mp="2sbczjy5896z0">
            {navLinks.map(link => {
            const isActive = location.pathname === link.path || link.dropdown && link.dropdown.some(sub => location.pathname === sub.path);
            if (link.dropdown) {
              return <div key={link.name} className="relative group py-2" data-id="element-93" data-mp="a523lbx62wau">
                    <button className={`flex items-center gap-1 text-sm font-medium transition-colors duration-200 ${isActive ? 'text-gold-400' : 'text-dark-100 hover:text-gold-300'}`} data-id="element-94" data-mp="a754iqzuy9uc">
                      {link.name} <ChevronDown className="w-4 h-4" data-id="element-95" data-mp="54xnvo4325lo" />
                    </button>
                    <div className="absolute left-0 top-full mt-0 w-56 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 transform translate-y-2 group-hover:translate-y-0 z-50" data-id="element-96" data-mp="surxzxx0pg28">
                      <div className="py-2 bg-dark-700 border border-dark-600 rounded-lg shadow-xl" data-id="element-97" data-mp="k1x2vx19l0q6">
                        {link.dropdown.map(sub => <Link key={sub.path} to={sub.path} className={`block px-4 py-2 text-sm transition-colors ${location.pathname === sub.path ? 'text-gold-400 bg-dark-600' : 'text-dark-100 hover:text-gold-300 hover:bg-dark-600'}`} data-id="element-98" data-mp="1bu5x0u9ltgzl">
                            {sub.name}
                          </Link>)}
                      </div>
                    </div>
                  </div>;
            }
            return <Link key={link.path} to={link.path} className={`text-sm font-medium transition-colors duration-200 ${location.pathname === link.path ? 'text-gold-400' : 'text-dark-100 hover:text-gold-300'}`} data-id="element-99" data-mp="3b3z3idn05k10">
                  {link.name}
                </Link>;
          })}
            <Link to="/donate" data-id="element-100" data-mp="3tzywnrrputm6">
              <button className="px-4 py-2 text-sm font-medium bg-gold-500 text-dark-900 rounded-md hover:bg-gold-400 transition-colors shadow-lg shadow-gold-500/20" data-id="element-101" data-mp="3u0rwe8s9ciut">
                Support
              </button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-102" data-mp="28b4m4uj86ogw">
            <button onClick={() => setIsOpen(!isOpen)} className="text-dark-100 hover:text-gold-400 transition-colors" aria-label="Toggle menu" data-id="element-103" data-mp="2d8mzcx49zpup">
              {isOpen ? <X size={24} data-id="element-104" data-mp="2m931a25deoxg" /> : <Menu size={24} data-id="element-105" data-mp="2m9l45hmjg1ec" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-106" data-mp="2r7weruknqfxm">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-dark-800 border-b border-dark-600 overflow-hidden" data-id="element-107" data-mp="2w7iohu1a1e1o">
            <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-108" data-mp="3ey05508u4j6o">
              {navLinks.map(link => {
            const isActive = location.pathname === link.path || link.dropdown && link.dropdown.some(sub => location.pathname === sub.path);
            if (link.dropdown) {
              return <div key={link.name} data-id="element-109" data-mp="1omv9qb7nxzi1">
                      <button onClick={() => setExpandedMobile(expandedMobile === link.name ? null : link.name)} className={`flex items-center justify-between w-full px-3 py-3 text-base font-medium rounded-md transition-colors ${isActive ? 'text-gold-400' : 'text-dark-100 hover:bg-dark-700 hover:text-gold-300'}`} data-id="element-110" data-mp="1jv3qymur0y2g">
                        {link.name}
                        <ChevronDown className={`w-5 h-5 transition-transform ${expandedMobile === link.name ? 'rotate-180' : ''}`} data-id="element-111" data-mp="d7ggniikrrs7" />
                      </button>
                      <AnimatePresence data-id="element-112" data-mp="2jv5xs9fli5kt">
                        {expandedMobile === link.name && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} className="overflow-hidden" data-id="element-113" data-mp="2ot7h8vgxo6wt">
                            <div className="pl-6 pr-3 py-2 space-y-1" data-id="element-114" data-mp="1w5urydje1kzt">
                              {link.dropdown.map(sub => <Link key={sub.path} to={sub.path} className={`block px-3 py-2 text-base font-medium rounded-md transition-colors ${location.pathname === sub.path ? 'text-gold-400 bg-dark-700' : 'text-dark-100 hover:bg-dark-700 hover:text-gold-300'}`} data-id="element-115" data-mp="3lhwug8hm8bcg">
                                  {sub.name}
                                </Link>)}
                            </div>
                          </motion.div>}
                      </AnimatePresence>
                    </div>;
            }
            return <Link key={link.path} to={link.path} className={`block px-3 py-3 text-base font-medium rounded-md transition-colors ${location.pathname === link.path ? 'bg-dark-700 text-gold-400' : 'text-dark-100 hover:bg-dark-700 hover:text-gold-300'}`} data-id="element-116" data-mp="1lkk086npnimp">
                    {link.name}
                  </Link>;
          })}
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}